import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SalesforceBulkReaderForm from '../forms/salesforce-bulk-reader-form';
import { salesforceBulkReaderValidationSchema } from '../schema/salesforceBulkReader';

export default function SalesforceBulkReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Salesforce Bulk Reader Node Details',
        altText: 'Salesforce Bulk Reader Node',
        defaultLabel: 'Salesforce Bulk Reader Node',
      }}
    >
      <CommonNode
        FormComponent={SalesforceBulkReaderForm}
        schemaResolver={salesforceBulkReaderValidationSchema}
      />
    </NodeProvider>
  );
}
